import React, { useState, useEffect } from 'react';

function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const AddProductPage = () => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const [formData, setFormData] = useState({
    pname: '',
    available: null,
    size: '',
    category: '',
    price: ''
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const windowSize = useWindowSize();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);

    // Create preview URLs
    const previews = files.map(file => URL.createObjectURL(file));
    setPreviewUrls(previews);
  };

  const removePreview = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    const newPreviews = previewUrls.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    setPreviewUrls(newPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.pname || !formData.size || !formData.category || !formData.price || formData.available === null) {
      setMessage('Please fill in all required fields');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      // First, add the product
      const productResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/add-product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api_key: apiKey,
          pname: formData.pname,
          available: parseInt(formData.available),
          size: formData.size,
          category: parseInt(formData.category),
          price: parseFloat(formData.price)
        }),
      });

      if (!productResponse.ok) {
        const error = await productResponse.json();
        setMessage(error.message || 'Failed to add product. Please try again.');
        setLoading(false);
        return;
      }

      const result = await productResponse.json();
      const newPid = result.pid;

      // Then, upload images if any are selected
      if (selectedFiles.length > 0) {
        const formDataImages = new FormData();
        formDataImages.append('api_key', apiKey);
        formDataImages.append('pid', newPid);
        
        
        selectedFiles.forEach((file) => {
          formDataImages.append('images', file);
        });

        const imageResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/upload-images`, {
          method: 'POST',
          body: formDataImages,
        });

        if (!imageResponse.ok) {
          alert(`Product added (ID: ${newPid}), but image upload failed.`);
          setLoading(false);
          return;
        }

        alert(`Product added successfully with images! Product ID: ${newPid}`);
      } else {
        alert(`Product added successfully! Product ID: ${newPid}`);
      }

      // Reset form
      setFormData({
        pname: '',
        available: null,
        size: '',
        category: '',
        price: ''
      });
      setSelectedFiles([]);
      setPreviewUrls([]);
      // Clear the file input
      const fileInput = document.getElementById('fileInput');
      if (fileInput) fileInput.value = '';

    } catch (error) {
      console.error('Error adding product:', error);
      setMessage('Error adding product');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({
      pname: '',
      available: null,
      size: '',
      category: '',
      price: ''
    });
    setSelectedFiles([]);
    setPreviewUrls([]);
    setMessage('');
    const fileInput = document.getElementById('fileInput');
    if (fileInput) fileInput.value = '';
  };

  return (
    <div>
    <div className="upload-container">
      <h2>Add New Product</h2>
      
      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <input
            type="text"
            id="pname"
            name="pname"
            value={formData.pname}
            onChange={handleInputChange}
            placeholder="Enter product name"
            required
          />
        </div>

        <div className="form-group">
          <input
            type="text"
            id="size"
            name="size"
            value={formData.size}
            onChange={handleInputChange}
            placeholder="Enter size (e.g., Small, Medium, Large)"
            required
          />
        </div>

        <div className="form-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <input
            type="number"
            id="price"
            name="price"
            value={formData.price}
            onChange={handleInputChange}
            placeholder="Enter price"
            step="0.01"
            min="0"
            required
          />
          {verticalSpacer(10)}

          <input
            type="number"
            id="available"
            name="available"
            value={formData.available || ''}
            onChange={handleInputChange}
            placeholder="Availability"
            step="1"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <input
            type="number"
            id="category"
            name="category"
            value={formData.category}
            onChange={handleInputChange}
            placeholder="Enter category (e.g., 1, 2)"
            step="1"
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="fileInput" style={{ fontSize: '14px', color: '#555', marginBottom: '5px' }}>
            Product Images (Optional):
          </label>
          <input
            type="file"
            id="fileInput"
            multiple
            accept="image/*"
            onChange={handleFileSelect}
            style={{
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          />
        </div>

        {previewUrls.length > 0 && (
          <div className="preview-section">
            <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>Selected Images ({previewUrls.length})</h3>
            <div className="preview-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
              gap: '15px',
              marginTop: '10px'
            }}>
              {previewUrls.map((url, index) => (
                <div key={index} className="preview-item" style={{
                  position: 'relative',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  padding: '5px'
                }}>
                  <img src={url} alt={`Preview ${index + 1}`} style={{
                    width: '100%',
                    height: '150px',
                    objectFit: 'cover',
                    borderRadius: '5px'
                  }} />
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => removePreview(index)}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(255, 0, 0, 0.8)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ×
                  </button>
                  <span style={{
                    display: 'block',
                    fontSize: '11px',
                    color: '#666',
                    marginTop: '5px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>{selectedFiles[index].name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="button-group">
          <button type="submit" className="upload-btn" disabled={loading}>
            {loading ? 'Adding Product...' : 'Add Product'}
          </button>
          <button type="button" className="reset-btn" onClick={handleReset} disabled={loading}>
            Reset
          </button>
        </div>

        {message && (
          <div className={`message ${message.includes('successfully') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </form>
      
    </div>
    {verticalSpacer((windowSize.width * 0.5) + (windowSize.height * 0.8))}
    </div>
  );
};

export default AddProductPage;